import { useContext } from "react";
import React from "react";
import { AuthContext } from "../Authorization/AuthContext";
import { ActionButton } from "./Buttons/ActionButton";
import { Tooltip } from "./Tooltip";

export const CopyEntityID = ({
  entityId,
  clipboard = navigator.clipboard,
  tooltipText,
}: {
  entityId: string;
  clipboard?: Pick<Clipboard, "writeText">;
  tooltipText: string;
}) => {
  const { admin } = useContext(AuthContext);

  if (!admin) {
    return null;
  }

  return (
    <Tooltip
      content={
        <ActionButton
          icon="copy"
          onPress={async () => {
            await clipboard.writeText(entityId);
          }}
          data-testid="copy-entity-id"
          aria-label="Copy entity ID"
        />
      }
      popoverContent={tooltipText}
      leftSpace={false}
    />
  );
};
